
























































import { Component, Vue } from 'vue-property-decorator';
import SidebarInfo from '@/components/common/SidebarInfo.vue';

@Component({
  components: {
    SidebarInfo,
  },
})
export default class SidebarTiles extends Vue {
  get wpUrl() {
    return process.env.VUE_APP_WORDPRESS_URL;
  }
}
